import Notice from '@@types/Notice';

import { channelNoticesStore } from '~/stores/ChannelNoticesStore';

class NoticeMessageHandler {
  handlePosted = (data: { channelId: string; notice: Notice }) => {
    channelNoticesStore.setPostedNotice(data);
  };

  handleUnposted = (data: { channelId: string; noticeId: string }) => {
    channelNoticesStore.removePostedNotice(data.channelId);
  };
}

export default NoticeMessageHandler;
